import { useSyncExternalStore, useCallback } from 'react'

export function createLocalStorageSync<T extends string>(
  storageKey: string,
  defaultValue: T,
  validate: (raw: string | null) => T | null,
) {
  const listeners = new Set<() => void>()

  function getSnapshot(): T {
    const raw = localStorage.getItem(storageKey)
    return validate(raw) ?? defaultValue
  }

  function subscribe(callback: () => void) {
    listeners.add(callback)
    return () => listeners.delete(callback)
  }

  function useStore(): readonly [T, (value: T) => void] {
    const value = useSyncExternalStore(subscribe, getSnapshot)

    const setValue = useCallback((next: T) => {
      localStorage.setItem(storageKey, next)
      listeners.forEach((l) => l())
    }, [])

    return [value, setValue] as const
  }

  return useStore
}
